import React, { useState, useContext, useEffect } from "react"
import SP from "./Filter/SP"
import PC from "./Filter/PC"
import { AreaContext, CategoryContext } from "../Common/FilterConditionsContext"
import { PCViewContext } from "../Common/PCViewContext"

import { GeolocationHandler } from "../Utils/geolocation_handler"
import { RequestHandler } from "../Utils/request_handler"
const geoHandler = new GeolocationHandler()
import {
  FilterConditionsHandler,
  FilterConditionsStorage,
} from "../Utils/filter_conditions_handler"
const filterhandler = new FilterConditionsHandler()
import Sentry from "../Common/Sentry"

const transferUsingGeo = async (category) => {
  const params = { latitude: "", longitude: "", category_id: "" }
  try {
    const coords: any = await geoHandler.getPosition()
    params.latitude = coords.latitude
    params.longitude = coords.longitude
  } catch (e) {
    Sentry.captureException(e)
    alert(
      "現在地の取得に失敗しました。エリアを選択してもう一度お試しください。"
    )
  }
  if (category) {
    params.category_id = category.id
  }
  const handler = new RequestHandler("/search", "POST", params)
  const res = await handler.requestWithBody()
  if (res.status != 200) {
    Sentry.captureMessage(res.body)
    alert("通信に失敗しました。時間を置いてもう一度お試しください。")
  }
  if (res.body.location) {
    document.location = res.body.location
  }
}

const Filter = (props) => {
  const [showLocationModal, setShowLocationModal] = useState(false)
  const [showCategoryModal, setShowCategoryModal] = useState(false)
  const locations = useContext(AreaContext)
  const categories = useContext(CategoryContext)
  const [showLoader, setShowLoader] = useState(false)
  const isPC = useContext(PCViewContext)

  const handleLocationClick = (e) => {
    e.preventDefault()
    setShowLocationModal(true)
  }
  const handleCategoryClick = (e) => {
    e.preventDefault()
    setShowCategoryModal(true)
  }
  const prefecture = props.prefecture
    ? locations
        .map((l) => l.prefectures)
        .flat()
        .find((p) => p.name == props.prefecture.name)
    : null

  const handleLocationSelected = async (city, pref, category) => {
    setShowLoader(true)
    let path = null
    if (city && city.path) {
      path = city.path
    } else if (pref && pref.path) {
      path = pref.path
    }
    if (!path) {
      await transferUsingGeo(props.category)
      return
    }
    if (category) {
      path = `${path}?category_id=${category.id}`
    }
    document.location = path
  }

  const handleCategorySelected = (category, location) => {
    setShowLoader(true)
    setShowCategoryModal(false)
    setShowLocationModal(false)
    const from = window.location.search.match("current_location")
      ? "current_location"
      : null
    let path = null
    if (category.path) {
      path = category.path
    }
    if (location) {
      path = category.path
        ? `${location.path}?category_id=${category.id}&from=${from}`
        : `${location.path}?from=${from}`
    }
    document.location = path
    setShowLoader(false)
  }

  const [placeCountByCategories, setPlaceCountByCategories] = useState({})

  useEffect(() => {
    let mounted = true
    const code = async () => {
      if (mounted) {
        if (prefecture == null) {
          return
        }
        const res = await filterhandler.fetchPlaceCounts({
          by: "category_id",
          prefecture_id: prefecture.id,
          city_id: props.city ? props.city.id : null,
        })
        setPlaceCountByCategories(res)
      }
    }
    code()
    return () => {
      mounted = false
    }
  }, [locations])

  useEffect(() => {
    FilterConditionsStorage.setCacheValues(
      props.category ? props.category.id : null,
      props.city ? props.city.id : null,
      props.prefecture ? props.prefecture.id : null
    )
  })

  const states = {
    locations,
    categories,
    prefecture,
    showLocationModal,
    showCategoryModal,
    setShowLocationModal,
    setShowCategoryModal,
    showLoader,
    handleLocationClick,
    handleCategoryClick,
    handleCategorySelected,
    handleLocationSelected,
    placeCountByCategories,
  }

  return (
    <React.Fragment>
      {isPC && <PC {...props} {...states} />}
      {!isPC && <SP {...props} {...states} />}
    </React.Fragment>
  )
}

export default Filter
